import { css } from "@emotion/react";
import React from "react";

export interface PaginationContainerProps extends React.ComponentPropsWithoutRef<"div"> {
  children?: React.ReactNode;
  size?: "small" | "medium";
}

export const PaginationContainer = ({
  size,
  ...props
}: PaginationContainerProps) => {
  return (
    <div
      css={css`
        display: flex;
        gap: ${size === "small" ? 4 : 8}px;
        align-items: center;
      `}
      {...props}
    />
  );
};
